/*
 * Project: forca
 * File Created: Wednesday, 20th October 2021 1:35:40 pm
 * Author: Teodor Moquist (teodor@moquist.dk)
 */

import React, { useState } from 'react';

import { TextDeckProps, TextDeckBox } from './textDeck.definition';

export const TextDeck = (props: TextDeckProps) => {
	const { title, boxes = [], elementMargin } = props;

	const [isSeperator, setIsSeperator] = useState(false);

	const renderBox = (item: TextDeckBox, index: number) => {
		if (!isSeperator && item.titleSeperator) {
			setIsSeperator(true);
		}

		return (
			<div
				className={ [
					'TextDeck-Box',
					item.titleSeperator ? 'TextDeck-Box--TitleSeperator' : ''
				].join(' ') }
				key={ index }
			>
				{ item.title && (
					<h3 className="TextDeck-Title">{ item.title }</h3>
				) }
				{ item.subtitle && (
					<p className="TextDeck-Subtitle">{ item.subtitle }</p>
				) }
				<div className="TextDeck-Hr" />
				<div className="TextDeck-Content" dangerouslySetInnerHTML={ { __html: item.content } } />
			</div>
		);
	};

	return (
		<div
			className={ [
				'TextDeck',
				elementMargin ? `mb-${elementMargin}` : ''
			].join(' ') }
		>
			{ title && (
				<h3 className="TextDeck-Headline">{ title }</h3>
			) }
			<div
				className={ [
					'TextDeck-Boxes',
					isSeperator ? 'TextDeck-Boxes--isBoxes' : '',
					!isSeperator && boxes.length >= 3 ? 'TextDeck-Boxes--ThreeColumns' : ''
				].join(' ') }
			>
				{ boxes.map((item, index) => renderBox(item, index)) }
			</div>
		</div>
	);
};

export default TextDeck;